import styled from "styled-components";
import { ButtonText } from "@loanbossinc/component-library";

export const TableWrapper = styled.div`
    overflow-x: scroll;
    height: 72vh;
    box-shadow: 0px 10px 20px 0px #ADAEAE40;
    border: 1px solid #DADCE0;

    table {
        position: relative;
        width: 100%;
        border-collapse: seperate;
        border-spacing: 0;
        overflow-x: scroll;
        font-family: 'Work Sans';
        margin-bottom: 30px;
    }

    // First Row
    table th {
        position: sticky;
        top: 0;
        z-index: 3;
    }

    // Column Names row
    table thead tr:nth-child(2) {
        position: sticky;
        top: 0;
        z-index: 5;
    }

    table thead tr:nth-child(2) th {
        white-space: pre-wrap;
    }

    // First Column, Second Header Row, First Cell ("Property Name" Cell)
    table thead tr:nth-child(2) th:nth-child(1) {
        left: 0;
        z-index: 4;
        background-color: #FAFAFA;
    }

    // First Column Table Cells ("Property Name" Column Cells)
    table tbody tr td:nth-child(1) {
        position: sticky;
        left: 0;
        z-index: 2;
        background-color: inherit;
    }

    thead tr {
        background: #FAFAFA;
        box-sizing: border-box;
        height: 64px;
    }

    thead tr th {
        border: 1px solid #DADCE0;
    }

    thead tr:first-child {
        color: #5F6368;
        text-align: left;
        height: 48px;
        text-transform: uppercase;
        font-size: 12px;
        line-height: 14px;
    }

    thead tr:first-child th {
        padding-left: 16px;
    }

    thead tr:nth-child(2) {
        font-size: 14px;
        font-weight: 300;
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }

    tbody tr {
        height: 64px;
    }

    table tbody tr:hover {
        background-color: #b7b7e8;
    }

    // Column Base Style
    tbody tr td {
        border: 1px solid #DADCE0;
        min-width: 170px;
        padding: 0px 16px;
        text-align: center;
        font-size: 14px;
    }

    // Property Name Column
    tbody tr td:first-child {
        text-align: left;
        color: #005AA9;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
    }

    // Units, Year Built, Occupancy, Year Acquired Columns
    tbody tr td:nth-child(n+8):nth-child(-n+11) {
        font-family: "Space Mono";
    }

    // Company Ownership % Column
    tbody tr td:nth-child(13) {
        font-family: "Space Mono";
    }

    // Maturity, Outstanding Loan Amount, Annual Debt Service Columns
    tbody tr td:nth-child(n+16):nth-child(-n+18) {
        font-family: "Space Mono";
    }

    // Outstanding Loan Amount, Annual Debt Service Columns
    tbody tr td:nth-child(n+17):nth-child(-n+18) {
        text-align: right;
    }

    // EGI, OPEX, Current NOI, DSCR, Market Value, Cap Rate, Value per Unit, LTV Columns
    tbody tr td:nth-child(n+20) {
        font-family: "Space Mono";
    }

    // EGI, OPEX, Current NOI Columns
    tbody tr td:nth-child(n+20):nth-child(-n+22) {
        text-align: right;
    }

    // Market Value Column
    tbody tr td:nth-child(24) {
        text-align: right;
    }

    // Value per Unit Column
    tbody tr td:nth-child(26) {
        text-align: right;
    }

    tbody tr:nth-of-type(odd) {
        background-color: #FFFFFF;
    }

    tbody tr:nth-of-type(even) {
        background-color: #F5F5F5;
    }
`;
export const StyledButtonText = styled(ButtonText)`&&&&{
    .material-icons {
       transform: rotate(0deg);
       }
}`;

export const ButtonWrapper = styled.div`
   display: flex;
   justify-content: space-evenly;
   align-content: center;
   flex-direction: row;
`;
export const TopButtonWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-content: center;
   flex-direction: row;
`;
export const CellContentWrapper = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
`;

export const StyledSubText = styled.div`
    /* Work Sans / 12 */

    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #C40A0A;
`;

export const PageTitle = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #000000;
    margin-bottom: 38px;
`;
